import type { BenefitResponse } from '@/domain/Benefit';
import { api } from '@/lib/api';

export const getBenefitsQuery = (page: number) => ({
  queryKey: ['adminIndicatorBenefits', page],
  queryFn: async () => {
    return await api
      .get('admin/ingredient-benefits', {
        searchParams: { page },
      })
      .json<BenefitResponse>();
  },
});

export const getAllBenefitsQuery = () => ({
  queryKey: ['adminIndicatorBenefits', 'all'],
  queryFn: async () => {
    return await api
      .get('admin/ingredient-benefits', {
        searchParams: { per_page: 500 },
      })
      .json<BenefitResponse>();
  },
});
